import { IInitialState } from './interface';
import produce from 'immer';
import { SET_DEFAULT_STATE } from './constants';

/**
 * Initial state
 */
export const initialState: IInitialState = {
    salesChannel: undefined,
    subscriptionId: undefined,
    gigakombi: false,
    gigakombiToken: undefined,
};

/**
 * Hardware detail reducer
 * @param state
 * @param action
 */
const tariffReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case SET_DEFAULT_STATE:
                draft.salesChannel = action.salesChannel;
                draft.subscriptionId = action.subscriptionId;
                draft.gigakombi = action.gigakombi;
                draft.gigakombiToken = action.gigakombiToken;
                break;
        }
    });

export default tariffReducer;
